import { render, staticRenderFns } from "./ButtonTooltip.vue?vue&type=template&id=01dad375&"
import script from "./ButtonTooltip.vue?vue&type=script&lang=js&"
export * from "./ButtonTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports